import React from 'react'

const AdditionalDescription = ({ data }) => {
    const { description } = data[0];

    return (
        <div className="aditional">
            <div className="aditional__header">
                <h2>Descripcion</h2>
            </div>
            <div className="additional__body">
                <p>{description}</p>
            </div>
        </div>
    )
}

export default AdditionalDescription
